export default __webpack_public_path__ + "static/media/question_exclamation.f7249951.jpg";